import type { IPricing } from "../config";

export const pricingMock: IPricing = {
  title: "Choose your plan",

  plans: {
    yearly: {
      price: 4.99,
      label: "billed annually",
      discount: {
        text: "-40% off",
        style: {
          fontSize: "12px",
          padding: "2px 8px",
          borderRadius: "9999px",
          backgroundColor: "var(--color-white)",
          color: "var(--color-cherrywood)",
          fontWeight: 600,
        },
      },
    },
    monthly: {
      price: 7.99,
      label: "",
      discount: null,
    },
  },

  featuresLeft: [
    { text: "Advanced AI models" },
    { text: "Unlimited summaries" },
    { text: "Personalized features" },
  ],

  featuresRight: [
    { text: "Chat with any video" },
    { text: "Video transcript access" },
    { text: "Multilingual support" },
  ],

  buttonText: "Get Started",
};
